import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import APP_ROUTES from '../../constants/app-routes';

class PaymentRedsysRedirectOk extends Component {
    constructor(props) {
        super(props);
        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
    }

    /* Render this step only if order is present and in a valid checkout state. */
    componentWillMount() {
        const { order } = this.props;
        this.props.setCurrentCheckoutStep();
        this.props.history.push(APP_ROUTES.checkout.completePageRoute);
    }

    componentDidMount() {
    }

    render() {
        const { order, stores } = this.props;

        return (
            <div>
                Transaccion confirmada
            </div>
        );
    }
}

export default injectIntl(withRouter(PaymentRedsysRedirectOk));



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment-redsys-redirect-ok.jsx
 **/